import { render, staticRenderFns } from "./ReceiptDeliveryDialog.vue?vue&type=template&id=ece2a5c6&scoped=true"
import script from "./ReceiptDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./ReceiptDeliveryDialog.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDeliveryDialog.vue?vue&type=style&index=0&id=ece2a5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece2a5c6",
  null
  
)

export default component.exports